import { render, staticRenderFns } from "./FYUserFinalize.vue?vue&type=template&id=78ea45be"
import script from "./FYUserFinalize.vue?vue&type=script&lang=js"
export * from "./FYUserFinalize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports